// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import makePathDbFormQuery from 'components/SearchAndSelect/helpers/makePathDbFormQuery'

import {
  assembleQuery,
  fetchPathsByQuery,
  makePaginationParams,
} from 'helpers/api'

const fetchData = ({ formProps, formValues, submittedFormIsPristine }) => {
  // if submitSucceeded was true, that means we want to make sure to persist the
  // defined page value for the query. Otherwise, reset the page.
  const page = (
    formValues.pagination && submittedFormIsPristine(formProps.form)
      ? +formValues.pagination.page
      : 0
  )

  // size of results set in API response - default to 300 count
  const size = 300

  const paginationParams = makePaginationParams({
    page,
    size,
  })

  const query = [
    ...paginationParams,
    makePathDbFormQuery(formValues),
  ]

  return fetchPathsByQuery(assembleQuery(query))
}

export default fetchData
